import React from "react";

export default function IcSetaEsquerda() {
  return (
    <svg
      height="12px"
      viewBox="0 0 9 12"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      style={{ transform: "rotate(180deg)" }}
    >
      <g>
        <path
          id="Fill-5605"
          d="M1.6,0.1c-0.1,0.1-0.1,0.3,0,0.4l5.3,5.3l-5.3,5.3c-0.1,0.1-0.1,0.3,0,0.4c0.1,0.1,0.3,0.1,0.4,0l5.5-5.5
          c0.1-0.1,0.1-0.3,0-0.4L1.9,0.1C1.9,0,1.8,0,1.8,0C1.7,0,1.6,0,1.6,0.1z"
        />
      </g>
    </svg>
  );
}
